import { Navigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { startPathFor } from '@/lib/roleEntry';

export function LandingPage(): JSX.Element {
  const { isAuthenticated, user } = useAuth();
  return <Navigate to={isAuthenticated && user ? startPathFor(user) : '/login'} replace />;
}
